import { SchoolSystemVerEnum } from './school-system-ver-enum'
import { SchoolStatusEnum } from './school-status-enum'
import { SchoolManager } from './school-manager'

export interface SchoolInterface {
  /**
   * 标识符
   */
  identity?: string | null
  /**
   * 域名
   */
  url?: string | null
  /**
   * 版本
   */
  systemVer?: SchoolSystemVerEnum | null
  /**
   * 状态
   */
  status?: SchoolStatusEnum | null
  hidden?: boolean
  /**
   * 过期时间
   */
  expiredAt?: string | null
  description: string
  /**
   * logo
   */
  logo?: string | null
  /**
   * 背景图
   */
  bgImage?: string | null
  /**
   * 主题色
   */
  themeColor?: string | null
  /**
   * 是否开启短信验证
   */
  openMsgCheck?: boolean
  /**
   * 本校绑定超管
   */
  manager?: SchoolManager | null
  name: string
  /**
   * 主键 ID
   */
  id: number
  /**
   * 创建时间
   */
  createdAt: string
  /**
   * 更新时间
   */
  updatedAt: string
}

export class School implements SchoolInterface {
  /**
   * 标识符
   */
  identity?: string | null
  /**
   * 域名
   */
  url?: string | null
  /**
   * 版本
   */
  systemVer?: SchoolSystemVerEnum | null
  /**
   * 状态
   */
  status?: SchoolStatusEnum | null
  hidden?: boolean
  /**
   * 过期时间
   */
  expiredAt?: string | null
  description: string
  /**
   * logo
   */
  logo?: string | null
  /**
   * 背景图
   */
  bgImage?: string | null
  /**
   * 主题色
   */
  themeColor?: string | null
  /**
   * 是否开启短信验证
   */
  openMsgCheck?: boolean
  /**
   * 本校绑定超管
   */
  manager?: SchoolManager | null
  name: string
  /**
   * 主键 ID
   */
  id: number
  /**
   * 创建时间
   */
  createdAt: string
  /**
   * 更新时间
   */
  updatedAt: string

  constructor(props: SchoolInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      identity: _identity,
      url: _url,
      systemVer: _systemVer,
      status: _status,
      hidden: _hidden,
      expiredAt: _expiredAt,
      description: _description,
      logo: _logo,
      bgImage: _bgImage,
      themeColor: _themeColor,
      openMsgCheck: _openMsgCheck,
      manager: _manager,
      name: _name,
      id: _id,
      createdAt: _createdAt,
      updatedAt: _updatedAt,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.identity = _identity
    this.url = _url
    this.systemVer = _systemVer
    this.status = _status
    this.hidden = _hidden
    this.expiredAt = _expiredAt
    this.description = _description
    this.logo = _logo
    this.bgImage = _bgImage
    this.themeColor = _themeColor
    this.openMsgCheck = _openMsgCheck
    this.manager = _manager ? new SchoolManager(_manager) : _manager
    this.name = _name
    this.id = _id
    this.createdAt = _createdAt
    this.updatedAt = _updatedAt
  }
}
